import React from "react";
import Convert from '../../common/Convert';
import InputBase from "./InputBase";
import {
    Input,
} from "reactstrap";

export default class InputRadio extends InputBase {
    static defaultProps = {
        disabled:false,
        label:'',
        labelOn:false,
        name:'',
        className:'',
        style:{},
        options:[],
        disabled_options:[],
    }

    constructor(props) {
        super(props);
        
        this.handle_change = this.handle_change.bind(this)
        this.handle_keyDown = this.handle_keyDown.bind(this);
    }

    handle_change(e) {
        this.validate(e.target.value)
    }

    handle_keyDown(e) {
        if (e.keyCode == 13) {
            super.focusNextNode(e);
        }
    }

    render() {
        const{
            disabled,
            disabled_options,
            name,
            rootData:{
                errors,
                values
            },
            options,
            labelOn,
            label,
            description,
            customMessage
        } = this.props
        
        const columnObject = Convert.key_split(name)
        var value = values&&values[columnObject.column]
        const validate_message = errors&&errors[columnObject.column]
        var default_value = options[0]["default"];
        if(!default_value){
            default_value = 0;
        }
        if(value === undefined || value === null){
            value = default_value;
        }

        return (
            <>
                {labelOn && <div>{label} : </div>}
                {options.map((data, index) => (
                    <label key={`${name}-${index}`}>
                        <Input className={`tabable`} disabled={disabled?disabled:disabled_options.includes(data.value)} type="radio" name={name} id={`${name}-${data.value}`} value={data.value} checked={String(value) === String(data.value)} onChange={this.handle_change}
                            onKeyDown={(e) => this.handle_keyDown(e)} />{data.label}&nbsp;
                    </label>
                ))}{description}
                {
                    validate_message instanceof Array && validate_message.length>0 &&
                    <p id={name} style={{ color: "red" }}>{validate_message.length>0?validate_message[0]:validate_message}</p>
                }
                {customMessage && <span>{customMessage}</span>}
            </>
        );
    }
}
